import { render, staticRenderFns } from "./CTASection.vue?vue&type=template&id=6cb1c644&scoped=true&"
import script from "./CTASection.vue?vue&type=script&lang=js&"
export * from "./CTASection.vue?vue&type=script&lang=js&"
import style0 from "./CTASection.vue?vue&type=style&index=0&id=6cb1c644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb1c644",
  null
  
)

export default component.exports